import clsx from 'clsx';
import { EyeIcon, EyeOffIcon } from 'lucide-preact';
import { ComponentProps } from 'preact';
import { useState } from 'preact/hooks';

import withDefaults from '@/components/withDefaults';

export const Section = withDefaults('div', {
  className: 'preflight rounded-2xl shadow-[2px_2px_13px_0px_rgba(0,0,0,0.15)]',
});

export const Header = withDefaults('div', {
  className: 'preflight border-b-2 border-stone-200 px-7 pb-4 pt-5',
});

export const HeaderTitle = withDefaults('h4', {
  className: 'preflight preflight-h4 text-pretty text-2xl font-bold text-black',
});

export const Content = withDefaults('div', {
  className: 'px-7 pb-6 pt-5',
});

export const FieldContainer = withDefaults('div', {
  className: 'flex flex-col gap-2',
});

export const FieldLabel = withDefaults('label', {
  className: 'text-xl font-medium text-stone-500',
});

export const FieldInput = withDefaults('input', {
  className:
    'preflight preflight-input rounded-lg border border-gray-300 px-3 py-2 text-base placeholder-zinc-500 data-[error]:border-red-500 desktop:max-w-[400px]',
});

export const FieldPasswordInput = ({ className, ...props }: ComponentProps<'input'>) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex flex-nowrap desktop:max-w-[400px]">
      <FieldInput
        type={showPassword ? 'text' : 'password'}
        className={clsx('min-w-0 grow rounded-r-none border-r-0', className)}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
      <button
        type="button"
        onClick={handleShowPassword}
        data-error={(props as any)['data-error']}
        className="preflight preflight-button flex shrink-0 items-center justify-center rounded-lg rounded-l-none border border-l-0 border-gray-300 p-3 text-zinc-500 data-[error]:border-red-500"
      >
        {showPassword ? <EyeIcon className="size-4" /> : <EyeOffIcon className="size-4" />}
      </button>
    </div>
  );
};

export const FieldError = withDefaults('p', {
  className: 'preflight preflight-p mt-1 text-red-500',
});

export const ButtonContainer = withDefaults('div', {
  className: 'flex flex-col justify-center desktop:flex-row desktop:justify-end',
});

export const PrimaryButton = withDefaults('button', {
  type: 'button',
  className:
    'preflight preflight-button min-w-[156px] rounded-full bg-primary-green px-4 py-3 text-base font-bold text-white hover:bg-secondary-green',
});
